export const OrderType = {
  Barcode: 0,
  Paper: 1,
  Color: 2,
  Sheet: 3,
};

export const OrderName = ["Barcode", "Paper", "Color", "Sheet"];
export const OrderTypeTitle = ["Barcode", "Paper Role", "Color", "Sheet"];
export const NotificationType = ["Barcode", "Paper", "Color", "Sheet"];
export const NotificationAction = ["created", "updated", "deleted"];

export const OrderStatus = [
  "New/Not Accepted",
  "Accepted",
  "Punching",
  "Splitting",
  "Dispatch",
  "Cancelled",
  "Deleted"
];

export const OrderStatusName = {
  "New/Not Accepted": 0,
  Accepted: 1,
  Punching: 2,
  Splitting: 3,
  Dispatch: 4,
  Cancelled: 5,
};
